/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectRenderGetVideoUrlQueryResponse, ProjectRenderGetVideoUrlPathParams, ProjectRenderGetVideoUrlQueryParams } from "../models/ProjectRenderGetVideoUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectRenderGetVideoUrl } from "../axios/projectRenderGetVideoUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const projectRenderGetVideoUrlQueryKey = (id: ProjectRenderGetVideoUrlPathParams["id"], params?: ProjectRenderGetVideoUrlQueryParams) => ["video-editor-api", { url: '/projects/:id/render/video-url', params: {id:id} }, ...(params ? [params] : [])] as const

export type ProjectRenderGetVideoUrlQueryKey = ReturnType<typeof projectRenderGetVideoUrlQueryKey>

export function projectRenderGetVideoUrlQueryOptions(id: ProjectRenderGetVideoUrlPathParams["id"], params?: ProjectRenderGetVideoUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = projectRenderGetVideoUrlQueryKey(id, params)
  return queryOptions<ProjectRenderGetVideoUrlQueryResponse, ResponseErrorConfig<Error>, ProjectRenderGetVideoUrlQueryResponse, typeof queryKey>({
   enabled: !!(id),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return projectRenderGetVideoUrl(id, params, config)
   },
  })
}

/**
 * @summary Get signed video URL for the rendered project
 * {@link /projects/:id/render/video-url}
 */
export function useProjectRenderGetVideoUrl<TData = ProjectRenderGetVideoUrlQueryResponse, TQueryData = ProjectRenderGetVideoUrlQueryResponse, TQueryKey extends QueryKey = ProjectRenderGetVideoUrlQueryKey>(id: ProjectRenderGetVideoUrlPathParams["id"], params?: ProjectRenderGetVideoUrlQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ProjectRenderGetVideoUrlQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? projectRenderGetVideoUrlQueryKey(id, params)

  const query = useQuery({
   ...projectRenderGetVideoUrlQueryOptions(id, params, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}